import classes from "../HomeScreen.module.css";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { useHistory } from "react-router";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import Utils from "../../../Utils";
import HeroBanner from "../../../assets/images/homebanner.jpg";
import HeroBannerMobile from "../../../assets/images/homebannermobile.jpg";

function HeroSection() {
  const history = useHistory();
  const theme = useTheme();
  const isMobScreen = !useMediaQuery(theme.breakpoints.up("sm"));

  const createBookHandler = () => {
    Utils.createBook(history);
  };

  return (
    <div className={classes.heroImageContainer}>
      <picture>
        <source media="(max-width: 768px)" srcSet={HeroBannerMobile} />
        <img
          src={HeroBanner}
          alt="Hero Banner for Independence Day"
          style={{ width: "100%", height: "auto" }}
        />
      </picture>
      <div
        className={
          isMobScreen ? classes.createMobileButton : classes.createButton
        }
      >
        <PrimaryButton onClick={createBookHandler}>
          Get Started Now!
        </PrimaryButton>
      </div>
    </div>
  );
}

export default HeroSection;
